import { Card, CardContent, Grid, Button, Typography } from '@mui/material'
import { ReactNode } from 'react'

interface QuickActionItem {
  label: string
  onClick: () => void
  icon?: ReactNode
  variant?: 'contained' | 'outlined' | 'text'
}

interface QuickActionsCardProps {
  actions: QuickActionItem[]
}

export const QuickActionsCard = ({ actions }: QuickActionsCardProps) => {
  const numActions = actions.length

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Quick Actions
        </Typography>
        <Grid container spacing={1.5}>
          {actions.map(action => (
            <Grid item xs={12} sm={6} md={Math.floor(12 / numActions)} key={action.label}>
              <Button
                fullWidth
                variant={action.variant ?? 'outlined'}
                startIcon={action.icon}
                onClick={action.onClick}
              >
                {action.label}
              </Button>
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  )
}
